import {
  Component,
  Input,
} from '@angular/core';

import {
  BadgeColor,
  GalaxyBadgeModule,
} from '@vendasta/galaxy/badge';
import { StandardIds } from '@galaxy/crm/services/field-service';
import {
  ObjectType,
  ProfileHeaderComponentInterface,
  TranslateByObjectTypePipe,
} from '@galaxy/crm/static';
import { CrmObjectInterface } from '@vendasta/crm';

@Component({
  selector: 'crm-lead-score-badge',
  imports: [GalaxyBadgeModule, TranslateByObjectTypePipe],
  templateUrl: './lead-score-badge.component.html',
  styleUrl: './lead-score-badge.component.scss',
})
export class LeadScoreBadgeComponent implements ProfileHeaderComponentInterface {
  @Input() crmObjectType: ObjectType | undefined;

  private _crmObject?: CrmObjectInterface;
  @Input()
  set crmObject(value: CrmObjectInterface) {
    this._crmObject = value;
    this.updateLeadScoreBadge();
  }
  get crmObject(): CrmObjectInterface | undefined {
    return this._crmObject;
  }

  leadScore: string | null = null;
  leadScoreBadgeColor: BadgeColor | null = null;

  private updateLeadScoreBadge() {
    const leadScoreFieldId = this.getLeadScoreFieldId(this.crmObjectType);
    const leadScoreField = this._crmObject?.fields?.find((f) => f.fieldId === leadScoreFieldId);
    this.leadScore = leadScoreField?.floatValue?.toString() || null;
    this.leadScoreBadgeColor = this.leadScore ? this.getColor(this.leadScore) : null;
  }

  getLeadScoreFieldId(objectType: string | undefined): string {
    switch (objectType) {
      case 'Company':
        return StandardIds.CompanyLeadScore;
      case 'Contact':
        return StandardIds.ContactLeadScore;
      default:
        return '';
    }
  }

  getColor(score: string): BadgeColor {
    const scoreNumber = parseFloat(score);
    if (scoreNumber > 0.5) {
      return 'green' as BadgeColor;
    } else if (scoreNumber < -0.5) {
      return 'red' as BadgeColor;
    } else {
      return 'yellow' as BadgeColor;
    }
  }
}
